import { css } from '@emotion/react'
import { Card, colors } from 'plume-ui'
import * as React from 'react'
import { People } from '../../../types'
import { A } from '../../atoms/A'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { SNSLinks } from '../../atoms/SNSLinks'
import { Table, TableCell } from '../../atoms/Table'
import { EmptyCard } from '../../common/EmptyCard'

type Props = {
  title: string
  list: People
  className?: string
}

export const PeopleTable: React.FC<Props> = (props) => {
  return (
    <Card className={props.className}>
      <CardInnerTitle title={props.title} />
      {props.list.length > 0 ? (
        <Table>
          <thead>
            <tr>
              <th>名前</th>
              <th
                css={css`
                  width: 70%;
                `}
              >
                役職 / 役割
              </th>
            </tr>
          </thead>
          <tbody>
            {props.list.map((p) => (
              <tr key={p.id}>
                <TableCell>
                  <div
                    css={css`
                      display: flex;
                      align-items: center;
                    `}
                  >
                    <A
                      href={p.path}
                      decoration="none"
                      css={css`
                        white-space: nowrap;
                      `}
                    >
                      {p.name}
                    </A>
                    <SNSLinks
                      twitter={p.twitter}
                      facebook={p.facebook}
                      color={colors.gray80}
                      iconSize={16}
                      css={css`
                        margin-left: 0.5rem;
                      `}
                    />
                  </div>
                </TableCell>
                <TableCell>
                  <div
                    css={css`
                      margin-top: 5px;
                    `}
                  >
                    {p.title}
                  </div>
                </TableCell>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <EmptyCard />
      )}
    </Card>
  )
}
